import BreadCrumb from '../../../_metronic/layout/components/breadcrumb'
import { Table, type ColumnType } from 'src/feature/bite/component/Table'
import { useImportGetList } from '../context/useQuery'
import { useFileUploadDownload } from '../context/useMutation'
import { getDateAndTime } from 'src/feature/bite/helpers/date'
import { useExports } from '../hook/list'
import { useIntl } from 'react-intl'

export default function ImportTasks() {
  const intl = useIntl()
  const { listFilterSet, listFilter } = useExports()
  const { data, isLoading } = useImportGetList()
  const { mutateAsync } = useFileUploadDownload()

  const list = data?.response?.dataList || []
  const pagination = data?.response?.paging || {}

  const types = {
    // 1: 'Member',
    1: intl.formatMessage({ id: 'TASK.MEMBER' }),
    // 2: 'Campaign',
    2: intl.formatMessage({ id: 'TASK.CAMPAIGN' }),
    // 3: 'Marketing',
    3: intl.formatMessage({ id: 'TASK.MARKETING' }),
    // 4: 'Product',
    4: intl.formatMessage({ id: 'TASK.PRODUCT' }),

    5: intl.formatMessage({ id: 'TASK.COUPON_CODES' }),
  }

  const status = {
    // 0: 'Waiting',
    // 1: 'Active',
    // 2: 'Inactive',
    // 3: 'Processing',
    // 4: 'Completed',
    // 5: 'Failed',
    // 6: 'Canceled',
    0: intl.formatMessage({ id: 'TASK.WAITING' }),
    1: intl.formatMessage({ id: 'TASK.ACTIVE' }),
    2: intl.formatMessage({ id: 'TASK.INACTIVE' }),
    3: intl.formatMessage({ id: 'TASK.PROCESSING' }),
    4: intl.formatMessage({ id: 'TASK.COMPLETED' }),
    5: intl.formatMessage({ id: 'TASK.FAILED' }),
    6: intl.formatMessage({ id: 'TASK.CANCELED' }),
  }

  const columns: ColumnType[] = [
    {
      title: '',
      dataIndex: '',
      key: '',
      render: (text: any, record: any) => (
        <div className='symbol symbol-50px me-5'>
          <span className='symbol-label bg-light-primary'>
            <i className='bi bi-file-earmark-arrow-up fs-2'></i>
          </span>
        </div>
      ),
    },
    {
      // title: 'Type',
      title: intl.formatMessage({ id: 'TASK.TYPE' }),
      dataIndex: 'type',
      key: 'type',
      render: (text: any, record: any) => <span>{intl.formatMessage({ id: 'TASK.PRODUCT' })}</span>,
    },
    {
      // title: 'Created On',
      title: intl.formatMessage({ id: 'TASK.CREATED_ON' }),
      dataIndex: 'date',
      key: 'date',
      render: (text: any, record: any) => <span>{getDateAndTime(record.date)}</span>,
    },
    {
      // title: 'Status',
      title: intl.formatMessage({ id: 'TASK.STATUS' }),
      dataIndex: 'status',
      key: 'status',
      render: (text: any, record: any) => (
        <span className={`badge badge-light-${record.status === 4 ? 'success' : 'info'}`}>
          {status[record.status]}
        </span>
      ),
    },
    {
      // title: 'Export Type',
      title: intl.formatMessage({ id: 'TASK.IMPORT_TYPE' }),
      dataIndex: 'fileExportType',
      key: 'fileExportType',
      render: (text: any, record: any) => {
        // const type = record.fileExportType === 1 ? 'CSV' : 'XLSX'

        return <span>XLSX</span>
      },
    },
    {
      title: intl.formatMessage({ id: 'TASK.ACTION' }),
      dataIndex: 'status',
      key: 'status',
      render: (text: any, record: any) => {

        if (record.status === 4) {

          return (
            <button
              className='btn btn-sm btn-primary'
              onClick={() => {
                mutateAsync({ id: record.id, type: 'xlsx', name: record.name })
              }}
            >
              {intl.formatMessage({ id: 'DOWNLOAD' })}
            </button>
          )
        }

        return <></>
      },
    },
  ]

  return (
    <>
      <BreadCrumb currentPage={intl.formatMessage({ id: 'IMPORT_TASKS' })} />
      <div className='card w-100 my-10'>
        <div className='card-header'>
          <h3 className='card-title'>{intl.formatMessage({ id: 'IMPORT_TASKS' })}</h3>
          <div
            className='card-toolbar'
            style={{
              width: '15%',
            }}
          >
            {/* <select className='form-select form-select-sm form-select-solid'>
              <option value=''>All</option>
              <option value='1'>Completed</option>
              <option value='2'>In Progress</option>
              <option value='3'>Cancelled</option>
            </select> */}
          </div>
        </div>
        <div className='card-body'>
          {/*  <div className='table-responsive'>
            <table className='table table-striped table-row-dashed fs-6 gy-5'>
              <thead>
                <tr>
                  <th className='p-0 w-50px'></th>
                  <th className='p-0 min-w-150px'></th>
                  <th className='p-0 min-w-140px'></th>
                  <th className='p-0 min-w-120px'></th>
                  <th className='p-0 min-w-120px'></th>
                  <th className='p-0 min-w-120px'></th>
                </tr>
              </thead>
              <tbody>
                {list.map((task) => (
                  <tr key={task.id} style={{ verticalAlign: 'middle' }}>
                    <td>
                      <div className='symbol symbol-50px me-5'>
                        <span className='symbol-label bg-light-primary'>
                          <i className='bi bi-file-earmark-arrow-down fs-2'></i>
                        </span>
                      </div>
                    </td>
                    <td>
                      <a href='#' className='text-gray-800 text-hover-primary fw-bolder fs-6'>
                        {types[task.type]} Export
                      </a>
                    </td>
                    <td>
                      <span className='text-muted fw-bold d-block mt-1'>{getDateAndTime(task.createdOn)}</span>
                    </td>
                    <td>
                      <span className='text-muted fw-bold d-block mt-1'>
                        {status[task.status]}
                      </span>
                    </td>
                    <td>
                      {task.status === 'In Progress' && (
                        <a href='#' className='btn btn-sm btn-light-primary'>
                          Cancel
                        </a>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className='d-flex justify-content-between align-items-center my-5'>
            <span className='text-muted'>Showing 1 to 5 of 5 entries</span>
            <Pagination currentPage={1} totalPages={10} setCurrentPage={() => { }} />
          </div> */}
          <Table
            loading={isLoading}
            dataSource={list}
            columns={columns}
            tableName={'files'}
            pagination={{
              current: pagination.currentPageNumber,
              pageSize: pagination.pageSize,
              total: pagination.totalCount,
              onChange: (page: any) => {
                const { pageSize, current } = page
                const currentPage = pageSize !== listFilter.paging.pageSize ? 1 : current

                listFilterSet({
                  ...listFilter,
                  paging: {
                    ...listFilter.paging,
                    currentPageNumber: currentPage,
                    pageSize,
                  },
                })
              },
            }}
          />
        </div>
      </div>
    </>
  )
}
